import {BaseApi} from "../BaseApi";
import {IHeader} from "@/interface/api/header";
import {HeaderApiResponse} from "@/types/api/header";

export default class HeaderServices extends BaseApi implements IHeader {

    getHeaderCategoryList = async (): Promise<HeaderApiResponse> => {
        try {
            return await this.get("header/categories" , {
                next : {
                    tags : ['header-categories'],
                    revalidate : 60,
                }
            })
        } catch (error) {
            return await Promise.reject(error)
        }
    };
}
